import * as React from "react";
import { useFocusRing } from "@react-aria/focus";
import { useTableCell, useTableColumnHeader } from "@react-aria/table";
import { Checkbox } from "@bolteu/kalep-react";
import { cx } from "../utils/cx";
import { ColumnHeaderContent } from "./ColumnHeader";
export function Cell({ cell, state }) {
    var _a, _b;
    const ref = React.useRef(null);
    const { gridCellProps } = useTableCell({ node: cell }, state, ref);
    const columnDefinition = (_a = cell.column) === null || _a === void 0 ? void 0 : _a.value;
    const align = (_b = columnDefinition.align) !== null && _b !== void 0 ? _b : "left";
    const handlePointers = React.useCallback((e) => e.stopPropagation(), []);
    return (React.createElement("td", Object.assign({}, gridCellProps, { className: cx("p-0 border-0 border-b border-solid border-separator align-middle", align === "left" ? "text-left" : "text-right"), ref: ref, onPointerDown: handlePointers, onMouseDown: handlePointers }), cell.rendered));
}
export function CheckboxCell({ cell, state, rowItem }) {
    const ref = React.useRef(null);
    const { gridCellProps } = useTableCell({ node: cell }, state, ref);
    return (React.createElement("td", Object.assign({ ref: ref }, gridCellProps, { className: cx("p-0 w-12 border-0 border-b border-solid border-separator align-middle") }),
        React.createElement("div", { className: cx("w-full h-full flex justify-center items-start p-3") },
            React.createElement(Checkbox, { checked: state.selectionManager.isSelected(rowItem.key), disabled: state.disabledKeys.has(rowItem.key), "aria-label": "Select row" }))));
}
export function HeaderCheckboxCell({ column, state }) {
    const ref = React.useRef(null);
    // We do not need the return values, but for some reason not calling this hook makes the focus behave oddly
    useTableColumnHeader({ node: column }, state, ref);
    const { focusProps } = useFocusRing();
    const handleChange = React.useCallback((event) => {
        if (event.target.checked) {
            state.selectionManager.selectAll();
        }
        else {
            state.selectionManager.clearSelection();
        }
    }, [state]);
    return (React.createElement("td", Object.assign({ ref: ref }, focusProps, { className: cx("p-0 w-12 h-11") }),
        React.createElement("div", { className: cx("w-full h-full flex items-center justify-center", "border-b border-separator") },
            React.createElement(Checkbox, { indeterminate: !state.selectionManager.isSelectAll && state.selectionManager.selectedKeys.size > 0, checked: state.selectionManager.isSelectAll, onChange: handleChange, "aria-label": "Select all rows" }))));
}
export function HeaderCell({ column, state, onFilterChange, compact, orderBy }) {
    var _a;
    const ref = React.useRef(null);
    const [width, setWidth] = React.useState(0);
    const { columnHeaderProps } = useTableColumnHeader({ node: column }, state, ref);
    const { focusProps } = useFocusRing();
    const columnDefinition = column.value;
    const sortDir = (orderBy === null || orderBy === void 0 ? void 0 : orderBy.key) === column.key ? orderBy === null || orderBy === void 0 ? void 0 : orderBy.direction : undefined;
    React.useEffect(() => {
        if (ref === null || ref === void 0 ? void 0 : ref.current) {
            setWidth(ref.current.clientWidth);
        }
    }, [ref]);
    return (React.createElement("th", Object.assign({}, columnHeaderProps, focusProps, { style: { width: (_a = columnDefinition.width) !== null && _a !== void 0 ? _a : "auto" }, className: cx("p-0", columnDefinition.align === "right" ? "text-right" : "text-left", "border-0 border-b border-solid border-separator "), ref: ref }),
        React.createElement(ColumnHeaderContent, { align: columnDefinition.align, sortable: columnDefinition.sortable, sortDir: sortDir, tooltip: columnDefinition.tooltip, tooltipProps: columnDefinition.tooltipProps, compact: compact, columnKey: column.key, column: columnDefinition, width: width, onFilterChange: onFilterChange }, column.rendered)));
}
